var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "#202020",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.976252 1.0297L1.05018 1.11725L6.63589 7.64148C6.82482 7.86243 7.10821 8 7.42446 8C7.74071 8 8.02411 7.85826 8.21304 7.64148L13.7946 1.12976L13.8891 1.02137C13.9589 0.917144 14 0.792079 14 0.658677C14 0.295988 13.6961 -1.32851e-08 13.3182 -2.98018e-08L1.53893 -5.44691e-07C1.16107 -5.61207e-07 0.857145 0.295987 0.857145 0.658676C0.857145 0.796248 0.902323 0.925481 0.976252 1.0297Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.69144b406dd7a522fe2f0915da72594d.svg";
export { ForwardRef as ReactComponent };